import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import {
  HeaderMarginTop as Main,
  MainWrapper,
  Center,
  BlueTopBar,
  BlueTopBarTitle,
} from 'legacyComponents/styled/lib';
import { BackButton } from 'legacyComponents/buttons/backButton';
import { EscButton } from 'legacyComponents/buttons/escButton';
import { Form } from 'libs/forms';
import { media, maxWidths } from 'legacyComponents/styled/styleUtils';
import { clientStore } from 'apps/client/app';

import { withConditional } from 'legacyComponents/hoc/conditional';

import { Trans, withNamespaces } from 'react-i18next';

@withNamespaces()
@observer
export class Wizard extends React.Component {
  componentDidMount() {
    clientStore.ScrollToTop();
  }

  UNSAFE_componentWillUpdate() {
    clientStore.ScrollToTop();
  }

  clickButton = () => {
    this.props.wizard.Next();
  };

  render() {
    const {
      wizard,
      isSideBarForm = false,
      spacing,
      maxResponsive,
      returnHandler,
    } = this.props;

    const { activeForm, completedForms, currentFlowStep, flowSteps } = wizard;
    const { Back, Quit, SetActiveFormName } = wizard;
    const currentStep =
      currentFlowStep >= 1
        ? `${currentFlowStep} of ${flowSteps}:`
        : activeForm.conf.step;
    const StepComponent = activeForm.component || Form;
    const FormView = (
      <StepComponent
        formStore={activeForm}
        optionHandler={SetActiveFormName}
        buttonHandler={this.clickButton}
        warning={activeForm.warning}
        message={activeForm.conf.message}
        noBorder={isSideBarForm}
        responsive={isSideBarForm}
        maxResponsive={maxResponsive}
        padding={isSideBarForm && '0'}
        isSideBarForm={isSideBarForm}
        spacing={spacing}
        wizard={wizard}
        returnHandler={returnHandler}
      />
    );
    if (isSideBarForm) {
      return FormView;
    }
    return (
      <Main>
        <BlueTopBar>
          <MainWrapper subPage fullWidthOnSmallScreens>
            {clientStore.windowWidth >= maxWidths.m && (
              <BackButton onclick={Back} />
            )}
            <EscButtonFirst
              condition={completedForms.length < 0}
              onclick={Quit}
              hidden={clientStore.windowWidth < maxWidths.m}
            />
            <BlueTopBarTitle elevated={activeForm.conf.description || false}>
              <Trans>{activeForm.conf.title}</Trans>
            </BlueTopBarTitle>
            {activeForm.conf.description && (
              <Description>
                <Trans>{activeForm.conf.description}</Trans>
              </Description>
            )}
            <Step elevated={activeForm.conf.description || false}>
              {currentStep}
            </Step>
          </MainWrapper>
          {/* Show smaller buttons if windowWidth is less than maxWidths.m */}
          {clientStore.windowWidth <= maxWidths.m && (
            <BackButton onclick={Back} small />
          )}
          <EscButton
            condition={completedForms.length < 0}
            onclick={Quit}
            hidden={clientStore.windowWidth > maxWidths.m}
            small
          />
        </BlueTopBar>
        <Center>
          <FormWrapper>{FormView}</FormWrapper>
        </Center>
      </Main>
    );
  }
}

const EscButtonFirst = withConditional(EscButton);

const Description = styled.h2`
  font-size: 1.0625em;
  color: ${props => props.theme.color.wfWhite};
  text-align: center;
  ${media.s`
    font-size: 0.8em;
    max-width: 80%;
    margin: 0 auto;
  `};
`;

const Step = styled.p`
  color: ${props => props.theme.color.wfWhite};
  font-weight: 600;
  margin: ${props => (props.elevated ? '40px 0 0 155px' : '58px 0 0 155px')};
  ${media.l`margin: ${props =>
    props.elevated ? '40px 0 0 98px' : '58px 0 0 98px'}`};
  ${media.m`margin: ${props =>
    props.elevated ? '40px 0 0 0' : '58px 0 0 0'}`};
  ${media.s`
    display: none;
  `};
`;

const FormWrapper = styled.div`
  margin: -45px 0 120px 0;
  position: relative;
  z-index: 2;
  ${media.s`
    margin: -45px 15px 120px 15px;
    width: 100%;
  `};
`;

Wizard.propTypes = {
  wizard: PropTypes.object,
  app: PropTypes.object,
  conf: PropTypes.object,
  cancel: PropTypes.func,
  returnHandler: PropTypes.func,
  isSideBarForm: PropTypes.bool,
  maxResponsive: PropTypes.bool,
  spacing: PropTypes.string,
};
